import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, Bell, Search } from 'lucide-react';
import ESSSidebar from './ESSSidebar';
import { useAuth } from '../../context/AuthContext';
import { ROLE_META } from '../../utils/roles';

export default function ESSLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const meta = ROLE_META[user?.role] || { label: user?.role, color: '#6C63FF' };

  return (
    <div className="app-layout">
      <ESSSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="app-main">
        {/* Topbar */}
        <header className="topbar">
          <button
            className="btn btn-icon btn-ghost"
            onClick={() => setSidebarOpen(true)}
            style={{ display: 'none' }} /* shown via media query override in global.css */
            aria-label="Open menu"
          >
            <Menu size={18} />
          </button>

          {/* Title / Branding */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 16, fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)' }}>
              Employee Self Service
            </span>
          </div>

          <div style={{ flex: 1 }} />

          {/* Notifications */}
          <button className="btn btn-icon btn-ghost" style={{ position: 'relative', marginRight: 12 }} aria-label="Notifications">
            <Bell size={17} style={{ color: 'var(--text-secondary)' }} />
          </button>

          {/* Role chip */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '4px 10px',
            borderRadius: 99,
            background: `${meta.color}12`,
            fontSize: 12,
            fontWeight: 500,
            color: meta.color,
          }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: meta.color }} />
            {meta.label}
          </div>
        </header>

        {/* Page content */}
        <main className="page" style={{ flex: 1, padding: '24px', overflowY: 'auto' }}>
          <Outlet />
        </main>

        {/* Footer */}
        <footer style={{
          padding: '12px 24px', fontSize: 12, color: 'var(--text-muted)',
          borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between',
          background: 'var(--surface-1)'
        }}>
          <span>© {new Date().getFullYear()} Linqsoft HR v1.0.0</span>
          <span style={{ opacity: 0.7 }}>ESS Portal</span>
        </footer>
      </div>

      {/* Mobile toggle */}
      <style>{`
        @media(max-width:768px){
          .topbar .btn-ghost[aria-label="Open menu"]{display:flex!important}
        }
      `}</style>
    </div>
  );
}
